<template>


<div class="clock" >
    
 
       {{timestamp}}
    </div>

</template>

<script>
export default{
  
  name: 'DateTimeWidget',
    data() {
        return  {
               timestamp: "",
            
               }

    },    
            created() {
               
                setInterval(this.getNow, 1000);
            },
            
            methods: {
                getNow: function() {
                    const     monthNames = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                           ];
                    const today = new Date();
                   // const date = today.getFullYear().toString().substr(-2)+'-'+(monthNames[today.getMonth()])+'-'+today.getDate();
                    const date = (monthNames[today.getMonth()])+'/'+today.getDate();
                    let sec=today.getSeconds() > 9? today.getSeconds():'0'+today.getSeconds();
                    let men=today.getMinutes() > 9? today.getMinutes():'0'+today.getMinutes();
                    let hr=today.getHours() > 9? today.getHours():'0'+today.getHours();

                    const time = hr + ":" + men + ":" + sec;

                    const dateTime = date +' '+ time;
                    this.timestamp = dateTime;
                }
            }
    }

</script>

<style scoped>
.clock {
    /* position: absolute; */
    top: 50%;
    left: 50%;
   /* transform: translateX(-50%) translateY(-50%); */
   /* background-color: rgb(223, 211, 211);
     */
    font-family: Orbitron;
    letter-spacing: 1px;
   


}
</style>